import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useHistory } from "react-router-dom";

const ModalConsentUpdate = ({ feasibility, doCloseModalConsent, opened,consent }) => {
    const history = useHistory();
    const [descripcion, setDescripcion] = React.useState(consent.descripcion);

    const [openModal, setOpenModal] = React.useState(opened);
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    React.useEffect(() => {

    }, []);

    const addConsentimiento = async () => 
    {
        //Validacion
        if (descripcion == null) {
            alertModal(false, "Descripcion");
            return;
        }

        let dataExcInc = new FormData();
        dataExcInc.append('id_consentimiento',consent.id_consentimiento);
        dataExcInc.append('descripcion',descripcion);

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}consentimiento-informado/update`, {
            method: 'PUT',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataExcInc
        }).then(response => {
            response.json();
        }).then(data => {
            refresh();
        }).catch(err => {

        });
    }

    const closeModal = () => 
    {
        doCloseModalConsent();
    }

    const refresh = () => 
    {
        let _url = "/clinical-studio/informed-consent";
        if (window.location.pathname === process.env.PUBLIC_URL + _url) {
            history.replace(process.env.PUBLIC_URL );
            setTimeout(() => {
                history.push({
                    pathname: process.env.PUBLIC_URL +_url,
                    state: feasibility
                });
            }, 0);
        }
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Actualizar Consentimiento Informado</h5>
                        </div>

                        <Row>
                            <Col md={12}>
                                <TextField
                                    multiline
                                    label=" "
                                    helperText="Descripcion"
                                    value={descripcion}
                                    rows={3}
                                    onChange={(event) => {
                                        setDescripcion(event.target.value);
                                    }}

                                    style={{ 
                                        minWidth: '200px',
                                        maxWidth: '100%' 
                                    }}

                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addConsentimiento();
                            }}
                        >
                            Actualizar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalConsentUpdate;
